import { render, staticRenderFns } from "./_DisposalRecycling.vue?vue&type=template&id=a768505a&scoped=true&"
import script from "./_DisposalRecycling.vue?vue&type=script&lang=js&"
export * from "./_DisposalRecycling.vue?vue&type=script&lang=js&"
import style0 from "./_DisposalRecycling.vue?vue&type=style&index=0&id=a768505a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a768505a",
  null
  
)

export default component.exports